//@ts-nocheck
import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import Typed from 'typed.js'
import Scrollbar from 'smooth-scrollbar'
import lottie from 'lottie-web'
import dataSource from './bm2019_backup.json'
import Logo from './components/Logo'
import './App.scss'

dataSource.forEach((o, i) => {
  o.index = i % 4
})

let stuckX = 0
let stuckY = 0

let activeIndex = null

const scrollMax = (window.innerWidth * 0.9 + (41 * window.innerHeight) / 1.7) / 1.5 + window.innerWidth

const App: React.FunctionComponent = () => {
  const cursor = useRef(null)
  const textRef = useRef<HTMLDivElement>(null)
  const titleRef = useRef<HTMLDivElement>(null)
  const particlesRef = useRef<HTMLDivElement>(null)
  const [stuck, setStuck] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    dataSource.forEach(o => {
      o.animation = lottie.loadAnimation({
        container: document.getElementById(`lottie_${o.aid}`),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: `//wxad.design/best-hearts/assets/lottie/${o.aid}/${o.aid}.json`,
      })
    })

    const scroll = Scrollbar.init(document.querySelector('#js-scroll'))

    const scrollListener = (): void => {
      const transformX = Math.round(scroll.offset.y * 1.5)

      const newActiveIndex = parseInt(
        (window.innerWidth + transformX - window.innerWidth * 0.9 - window.innerHeight / 3.4) /
          (window.innerHeight / 1.7),
        10
      )

      if (newActiveIndex !== activeIndex) {
        activeIndex = newActiveIndex
        document.querySelectorAll('.competitor').forEach((el, i) => {
          if (el) {
            if (Math.abs(i - newActiveIndex) < 5) {
              el.style.display = 'block'
            } else {
              el.style.display = 'none'
            }

            if (i === newActiveIndex && !el.classList.contains('competitor_show')) {
              setTimeout(() => {
                el.classList.add('competitor_show')
                setTimeout(() => {
                  dataSource[i].animation.goToAndPlay(1)
                  setTimeout(() => {
                    dataSource[i].animation.pause()
                  }, dataSource[i].generate_time)

                  const wordings = el.querySelectorAll('.competitor-wording-parts')
                  wordings.forEach(wording => {
                    if (wording) {
                      new Typed(wording, {
                        strings: [wording.dataset.content],
                        typeSpeed: 120,
                        showCursor: false,
                      })
                    }
                  })
                }, 1800)
              }, 10)
            }
          }
        })
      }

      if (transformX > window.innerWidth) {
        textRef.current.style.display = 'none'
      } else {
        textRef.current.style.display = 'block'
      }

      document.documentElement.style.setProperty('--scroll-y', transformX + 'px')

      particlesRef.current.style.transform = `translate3d(${Math.min(transformX / 3, window.innerWidth / 3)}px, 0, 0)`
      titleRef.current.style.transform = `translate3d(${Math.min(transformX / 3, window.innerWidth / 3)}px, 0, 0)`
    }

    setTimeout(() => {
      setLoading(false)

      scroll.addListener(scrollListener)
      let clientX = -100
      let clientY = -100
      const pageCursor: HTMLDivElement = cursor.current || document.createElement('div')

      const initCursor = (): void => {
        document.addEventListener('mousemove', e => {
          clientX = e.clientX
          clientY = e.clientY
        })
        const render = (): void => {
          if (pageCursor) {
            pageCursor.style.transform = `translate(${clientX}px, ${clientY}px)`
            document.documentElement.style.setProperty('--mouse-x', clientX + 'px')
            document.documentElement.style.setProperty('--mouse-y', clientY + 'px')
          }
          requestAnimationFrame(render)
        }
        requestAnimationFrame(render)
      }

      const handleMagnetMouseEnter = (e: MouseEvent): void => {
        const { currentTarget } = e
        const rect = currentTarget.getBoundingClientRect()
        stuckX = Math.round(rect.left + rect.width / 2)
        stuckY = Math.round(rect.top + rect.height / 2)
        setStuck(true)

        console.log(stuckX, stuckY, 'yijie')
      }

      // reset isStuck on mouseLeave
      const handleMagnetMouseLeave = (): void => {
        setStuck(false)
      }

      const initMagnets = (): void => {
        const magnets = document.querySelectorAll('.magnet')
        magnets.forEach(magnet => {
          magnet.addEventListener('mouseenter', handleMagnetMouseEnter)
          magnet.addEventListener('mouseleave', handleMagnetMouseLeave)
        })
      }

      initCursor()

      initMagnets()

      document.documentElement.style.setProperty('--scroll-y', '0px')
      document.documentElement.style.setProperty('--mouse-x', 280 + 'px')
      document.documentElement.style.setProperty('--mouse-y', 540 + 'px')
    }, 5000)
  }, [])

  const titleShapeTransformValue = `translate3d(calc(var(--mouse-x) + var(--scroll-y) - 150px), calc(var(--mouse-y) - 35vh), 0) rotate(-45deg)`

  return (
    <>
      <div
        className={classNames('loading', {
          ['loading_done']: !loading,
        })}
      >
        <div className="load-btn-inner-heart-wrapper">
          <div className="load-btn-inner-heart">
            <svg width="10" height="10">
              <path
                d="M5 .859A2.926 2.926 0 00.859.86a2.938 2.938 0 000 4.151l4.143 4.156L9.14 5.01a2.938 2.938 0 000-4.15 2.925 2.925 0 00-4.14-.002z"
                fill="#12A2EC"
                fillRule="evenodd"
                opacity=".5"
              />
            </svg>
          </div>
          <div className="load-btn-inner-heart">
            <svg width="10" height="10">
              <path
                d="M5 .859A2.926 2.926 0 00.859.86a2.938 2.938 0 000 4.151l4.143 4.156L9.14 5.01a2.938 2.938 0 000-4.15 2.925 2.925 0 00-4.14-.002z"
                fill="#ECC712"
                fillRule="evenodd"
                opacity=".5"
              />
            </svg>
          </div>

          <div className="load-btn-inner-heart">
            <svg width="10" height="10">
              <path
                d="M5 .859A2.926 2.926 0 00.859.86a2.938 2.938 0 000 4.151l4.143 4.156L9.14 5.01a2.938 2.938 0 000-4.15 2.925 2.925 0 00-4.14-.002z"
                fill="#07C160"
                fillRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>
      <div style={{ height: '100vh', overflow: 'hidden' }}>
        <div id="js-scroll" style={{ height: '100vh' }}>
          <div id="js-scroll-content" style={{ height: scrollMax }}></div>
        </div>
      </div>
      <div
        className={classNames('app', {
          ['app_notready']: loading,
          ['app_ready']: !loading,
        })}
      >
        <div className="app-wrapper" style={{ transform: 'translate3d(calc(0px - var(--scroll-y)), 0, 0)' }}>
          <div className="particle-inits">
            {Array.from(new Array(20), (_, i) => ({ key: i })).map(o => (
              <i key={o.key} />
            ))}
          </div>
          <div className="first-page">
            <h1 className="logo magnet">
              <Logo />
            </h1>
            <div className="desc">
              <div>
                Each year, we select 40 WeChat Moments ads to be celebrated as MOST LIKED ADS of the year, <br />
                We name this annual event as <strong>Best Moments</strong>.
                <br />
                <br />
                In 2019, we designed these animations inspired by each of them,
                <br />
                to encourage more innovation, elegance and creativity.
                <br />
                So we call them <strong>Best Hearts</strong>.
              </div>
            </div>
            <h1 className="title" ref={titleRef}>
              <div className="title-shapes" ref={textRef}>
                <div
                  className="title-shapes-0"
                  style={{
                    transform: titleShapeTransformValue,
                  }}
                />
                <div
                  className="title-shapes-1"
                  style={{
                    transform: titleShapeTransformValue,
                  }}
                />
                <div
                  className="title-shapes-2"
                  style={{
                    transform: titleShapeTransformValue,
                  }}
                />
              </div>
              <div className="title-texts">
                <div
                  style={{
                    overflow: 'hidden',
                  }}
                >
                  <div className="title-texts-inner-0">
                    Best He
                    <span>
                      a<i></i>
                    </span>
                    rts
                  </div>
                </div>
                <div>
                  <div className="title-texts-inner-1">of 2019</div>
                </div>
              </div>
            </h1>
          </div>
          <div className="particles" ref={particlesRef}>
            {Array.from(new Array(20), (_, i) => ({ key: i })).map(o => (
              <i key={o.key} />
            ))}
          </div>
          <div className="competitors">
            {dataSource.map((o, i) => (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: `calc(90% + 100vh / 1.7 * ${i})`,
                  display: 'none',
                }}
                key={o.aid}
                className={classNames('competitor', `competitor_${o.aid}`, {
                  ['competitor_even']: o.index === 0,
                  ['competitor_odd']: o.index === 1,
                  ['competitor_even_4']: o.index === 2,
                  ['competitor_odd_4']: o.index === 3,
                })}
              >
                <div className="competitor-inner">
                  <div className="competitor-lottie">
                    <div className="competitor-lottie-wrapper">
                      <div className="competitor-lottie-inner" id={`lottie_${o.aid}`}></div>
                    </div>
                    <div
                      className="competitor-text"
                      style={{ color: o.light_background ? 'rgba(0, 0, 0, 0.45)' : 'rgba(255, 255, 255, 0.8)' }}
                    >
                      <div className="competitor-text-inner">
                        <div className="competitor-name" data-content={o.vote_name}>
                          {o.vote_name}
                        </div>
                        <div className="competitor-wording">
                          {o.wording[0].split('\n').map(p => (
                            <div key={p} className="competitor-wording-parts" data-content={p}></div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="competitor-card" style={{ backgroundColor: o.background_color }}>
                    <div className="competitor-bg-base" />
                    <div className="competitor-bg-animations">
                      {Array.from(new Array(10), (_, i) => ({ key: i })).map(o => (
                        <i key={o.key} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className={classNames('app-cursor', {
          'app-cursor_stuck': stuck,
        })}
        ref={cursor}
      >
        <div className="app-cursor-inner" />
      </div>
    </>
  )
}

export default App
